import { createContext, useEffect, useMemo, useState, useContext } from 'react';

import api from 'services/apiService';

const StatusContext = createContext({});

const StatusProvider = props => {
  const [status, setStatus] = useState({ maintenanceMode: false });

  const fetchStatus = async () => {
    try {
      const response = await api({ url: '/status/GetSiteStatus' });

      if (response?.data) {
        setStatus(response.data);
      } else {
        // eslint-disable-next-line no-console
        console.error('no response.data set from GetSiteStatus request, response is ', response);
        setStatus({
          maintenanceMode: true,
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Catch error handling on GetSiteStatus error is ', error);
      setStatus({
        maintenanceMode: true,
      });
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  useEffect(() => {
    if (status.maintenanceMode) {
      setTimeout(() => fetchStatus(), 2000);
    }
  }, [status]);

  const value = useMemo(() => ({ status }), [status]);

  return <StatusContext.Provider value={value} {...props} />;
};

const useStatus = () => useContext(StatusContext);

export { StatusProvider, useStatus };
